/* eslint-disable no-unused-expressions */
import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { injectIntl } from "react-intl";
import * as auth from "../../modules/Auth/_redux/authRedux";
import SVG from "react-inlinesvg";
import { toAbsoluteUrl } from "../../../_metronic/_helpers";
import * as crud from "./operations";
import * as _locations from "../CatalogLocations/operations";
import * as tasks from "../CatalogTasks/operations";
import * as _client from "../CatalogClients/operations"
// import * as _invoices from "../CatalogCampaignInvoices/operations";
// import * as _payments from "../CatalogCampaingPayments/operations"
import { GenerateReport, ExportReport } from "./generateXLSV2";
import { useSelector } from "react-redux";
import { Field, Form, Formik } from "formik";
import * as Yup from "yup";

import "react-awesome-lightbox/build/style.css";
import {
  Button,
  Nav,
  Tab,
  Badge,
  Row,
  Col,
  Modal
} from "react-bootstrap";
import Axios from "axios";
import { useHistory } from "react-router-dom";
import moment from "moment";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min.css";
import "react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css";
import "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min.css";
import { Input, Select } from "../../../_metronic/_partials/controls";

/* Styles */
import "../../../styles/app/pages/CampaingPreview.scss";

//Components
import Report from "./Components/Reports/Reports";
import Agents from "./Components/Agents";
import Tasks from "./Components/Task";
import Products from "./Components/Products";
import Results from "./Components/Results";
import Catalog from "./Components/Catalog";
import Charts from "./Components/Charts";
import PlanoGram from "./Components/Planogram"
import POSCard from "./Components/POS"
function diff_minutes(dt2, dt1) {
  var diff = (dt2.getTime() - dt1.getTime()) / 1000;
  diff /= 60;
  return Math.round(diff);
}


function RepeatCampaign(props) {
  const [loading, setloading] = useState(false)
  const uid = props.campaing.parent || props.campaing.uid
  function repeat() {
    setloading(true)
    const campaign = props.campaing
    delete campaign.uid
    const wave = campaign.max_wave ?? campaign.wave
    crud.updateClient({ ...campaign, wave: wave + 1, parent: uid }).then(({ data }) => {
      crud.updateClient({ uid, max_wave: wave + 1 }).then(({ data }) => {
        window.location.href = "/campaign/preview/" + data.payload.parent
      })
    })
  }
  return (
    <Modal show={props.show} onHide={props.onHide}>
      <Modal.Header>
        Repeat Campaign
      </Modal.Header>
      <Modal.Body>
        <h4>Do you want <Badge variant="danger">repeat</Badge> this campaing?</h4>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={props.onHide}>
          No
        </Button>
        <></>
        <Button variant="success"
          disabled={loading}
          onClick={() => {
            setloading(true)
            repeat()
          }}>
          {loading ?
            <div className="d-flex align-items-center">
              <div className="mr-2">Loading...</div>
              <div className="spinner spinner-white mr-10"></div>
            </div> : "Repeat"}
        </Button>
      </Modal.Footer>
    </Modal>
  )
}
export function priceStringFormatter(value) {
  return String(process.env.REACT_APP_CURRENCY + "" + Number(value ?? 0).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ","))
}
function PaymentWrapper(props) {
  return (
    <>
      <Modal show={props.payment_show} onHide={props.togglePayment} size="lg" dialogClassName="p-5">
        <Modal.Header>
          <h1>New Payment</h1>
        </Modal.Header>

        <PaymentForm {...props} />
      </Modal>
    </>
  );
}
function PaymentForm({ doPayment, document = {}, togglePayment }) {
  ////console.log("invoice", invoice);
  const invoice = document.invoice ?? {}
  const [isSubmitting, setSubmitting] = useState(false);
  const { user } = useSelector((state) => state.auth);
  const userDocument = user.uid ? user : user.payload;
  const balance = Number((invoice.total ?? 0) - (invoice.payments ?? 0))
  const Schema = Yup.object().shape({
    amount: Yup.number().max(
      balance + 0.1,
      `Cannot be bigger than invoice balance (${process.env.REACT_APP_CURRENCY}${balance.toFixed(2)})`
    ),
  });
  return (
    <>
      <Formik
        validateOnBlur={false}
        validateOnChange={false}
        initialValues={{ payment_type: "cash" }}
        validationSchema={Schema}
        onSubmit={(values) => {
          doPayment({
            campaign: document.uid,
            payment_type: values.payment_type,
            ...values,
            author: userDocument.uid
          });
        }}
      >
        {({ handleSubmit, errors, handleChange, values }) => (
          <>
            <Modal.Body className="cursor-default">
              <Form className="form form-label-right">
                <div className="form-group row">

                  <div className="col-lg-6">
                    <Select name="payment_type" label="Type" >
                      {["cash", "check", "transfer",].map((move) => (
                        <option
                          key={move}
                          value={move}
                        >
                          {move}
                        </option>
                      ))}
                    </Select>
                  </div>
                  <div className="col-lg-6">
                    <Field
                      type="text"
                      errors={errors}
                      name="reference_number"
                      component={Input}
                      values={values}
                      placeholder="Reference"
                      label={"Reference Number"}
                    />
                  </div>
                  {/* {values.payment_type === "programmed" && <div className="col-lg-6  ">
                    <br />
                    <Field
                      type="date"
                      errors={errors}
                      name="write"
                      component={Input}
                      values={values}
                      placeholder="Date"
                      label={"Date"}
                    />


                  </div>} */}
                  <div className="col-lg-6">
                    <br />


                    <label>Balance</label>
                    <h3><strong className="text-danger">{priceStringFormatter(balance)}</strong>
                      {values.amount > 0 ? <> - <strong>{priceStringFormatter(values.amount)}</strong> = <strong className={!(balance - values.amount) ? "text-success" : "text-danger"}>{priceStringFormatter(balance - values.amount)}</strong></> : null}
                    </h3>

                    <br />
                    <Field
                      type="number"
                      errors={errors}
                      name="amount"
                      values={values}

                      component={Input}
                      placeholder="Amount"
                      label="Amount"
                      onChange={handleChange}
                    />

                  </div>
                  {/* <div className="col-lg-2">
                    <br />

                    <label>New Balance</label>
                    <h3><strong >{priceStringFormatter(balance - values.amount)}</strong></h3>
                  </div> */}
                </div>
              </Form>
            </Modal.Body>
            <Modal.Footer>
              <button type="button" onClick={togglePayment} className="btn btn-light btn-elevate">
                Cancel
              </button>
              <> </>
              <button
                onClick={() => {
                  setSubmitting(true);
                  handleSubmit();
                  setTimeout(() => setSubmitting(false), 500);
                }}
                disabled={isSubmitting}
                className="btn btn-primary btn-elevate"
              >
                {isSubmitting ? (
                  <div className="d-flex align-items-center">
                    <div className="mr-2">Loading...</div>
                    <div className="spinner spinner-white mr-10"></div>
                  </div>
                ) : (
                  "Save"
                )}
              </button>
            </Modal.Footer>
          </>
        )}
      </Formik>
    </>
  );
}
function CampaingsPreview(props) {
  const [campaing_uid] = window.location.pathname.split("/").reverse();

  const { user } = useSelector((state) => state.auth);
  const current = user.uid ? user : user.payload;
  const history = useHistory()
  const [show_agent, togleShow] = useState(false);
  const [agent, setAgent] = useState({});
  const [delete_show, setDeleteShow] = useState(false);
  const [repeat, setRepeat] = useState(false)

  const [usersTraces, setTraces] = useState([]);
  const [campaign, setActiveCampaign] = useState({
    states: []
  });
  const [locations, setActiveLocation] = useState([]);
  const [client, setClient] = useState({})

  const [activaTab, setActiveTab] = useState("products");
  const [_tasks, setTasks] = useState([]);
  const [_products, setProducts] = useState([]);
  const [_users, setUsers] = useState([]);
  const [allTraces, setallTraces] = useState([]);
  const [_rows, setRows] = useState([])
  const [_competition, serCompetition] = useState([])
  const [invoices, setInvoices] = useState([])

  const [posv, setPosV] = useState("Cargando...")

  const [queryng_tasks, setQueryngTaks] = useState(true)
  const [queryng_agents, setQueryngAgents] = useState(true)
  const [queryng_products, setQueryngProducts] = useState(true)
  const [quering_results, setQueryRows] = useState(true)
  useEffect(() => {
    crud
      .getPreview(campaing_uid)
      .then(async (snap) => {
        const { payload } = snap.data;
        setActiveCampaign({ uid: campaing_uid, ...payload.campaing });
        // const gps = payload.gps.map((traces) => {
        //   const color = `#${Math.floor(Math.random() * 16777215).toString(16)}`;
        //   const _traces = traces.map((trace) => ({ ...trace, color }));
        //   return _traces;
        // });
     
        // setTraces(gps);
        // setallTraces(gps);

        Axios.post(
          process.env[`REACT_APP_${process.env.REACT_APP_ENV.toUpperCase()}_URL`] + "/v1/users/find"
        ).then(({ data }) => {
          const ids = payload.campaing.users;
          const _users = data.payload.filter((i) => ids.includes(i.uid));
          setUsers(_users);
          setQueryngAgents(false)
        });
        Axios.post(
          process.env[`REACT_APP_${process.env.REACT_APP_ENV.toUpperCase()}_URL`] + "/v1/products/populate", { uids: Object.keys(payload.campaing.products) }
        ).then(({ data }) => {
          const _products = data.payload
          setProducts(_products);
          setQueryngProducts(false)
          // results.push(data.payload);
        });

        _locations.getClients(setActiveLocation)

        tasks.getClient().then(({ data }) => {
          const ids = payload.campaing.tasks;
          const _tasks = data.payload.filter((i) => ids.includes(i.uid));
          setTasks(_tasks);
          setQueryngTaks(false)
          // results.push(data.payload);
        });
        _client.getClient(payload.campaing.client).then((res) => {

          setClient(res.data.payload)
        })

      })
      .catch((err) => {
        //window.location.href = "/campaign"
      });
  }, [campaing_uid]);
  const hideTrace = (uid) => {
    const ids = usersTraces.map((user) => user[0]?.user_id).filter(Boolean);
    if (ids.includes(uid)) {
      const newUserTrces = usersTraces.filter((user) => {
        const [info] = user;
        return info?.user_id !== uid;
      });
      setTraces(newUserTrces);
    } else {
      const [trace] = [...allTraces].filter(trace => trace[0]?.user_id === uid)
      setTraces([trace, ...usersTraces]);

    }
  };
  const start_future = moment(`${campaign.start_date} ${campaign.start_time}`).toDate()
  const end_future = moment(`${campaign.end_date} ${campaign.end_time}`).toDate()
  const today = moment().toDate()

  const minuts_start = diff_minutes(start_future, today)
  const minuts_end = diff_minutes(end_future, today)
  const state = campaign.mode === "draft" ? "DRAFT" : minuts_start > 0 ? "Waiting for start" : minuts_end > 0 ? "On Going" : "Done"

  const controllers = {
    setActiveCampaign: setActiveCampaign,
    document: campaign,
    state: state,
    allTraces: allTraces,
    usersTraces: usersTraces,
    current: current,
    campaign: campaign,
    payment_show: show_agent,
    delete: delete_show,
    agent: agent,
    agents: _users,
    tasks: _tasks,
    products: _products,
    traces: allTraces,
    hideTrace: hideTrace,
    togglePayment: () => togleShow(!show_agent),
    handleTogle: () => togleShow(!show_agent),
    handleClose: () => togleShow(false),
    doPayment: (doc) => {
     
    },
    handleShow: (user) => {
      setAgent(user);
      togleShow(true);
    },
    hideDelete: () => setDeleteShow(!delete_show),
  };
  const round = campaign.max_wave ?? campaign.wave

  const pos = locations.filter(lct => campaign.pos.includes(lct.uid))
  const variants = {
    "DRAFT": "danger",
    "Waiting for start": "primary",
    "On Going": "warning",
    "Done": "success"
  }

  function General() {
    return (
      <>
        <div className="card shadow-sm m-2 rounded-xl">
          <div className="row">
            <div className="col-12">

              <div className="row p-10 pl-1">
                <div className="col-3">
                  <div className="row">
                    <div className="col-md-3 col-lg-3 pt-1">
                      <i class="fas fa-store fa-3x" style={{ color: "#5E78FF" }}></i>
                    </div>
                    <div className="col-md-9 col-lg-9">
                      <label>
                        <strong>
                          Campaign Name
                        </strong>
                      </label>
                      <h4>{campaign.name}</h4>
                    </div>
                  </div>
                </div>
                <div className="col-2">
                  <div className="row">
                    <div className="col-md-3 col-lg-3 pt-1">
                      <i class="fas fa-globe-americas fa-3x" style={{ color: "#5E78FF" }}></i>
                    </div>
                    <div className="col-md-9 col-lg-9">

                      <label>
                        <strong>
                          State(s)
                        </strong>
                      </label>
                      <h4 >{typeof campaign.state === "string" ? campaign.state : campaign.states.join(", ")}</h4>
                    </div>
                  </div>

                </div>

                <div className="col-2">
                  <div className="row">
                    <div className="col-md-3 col-lg-3 pt-1">
                      <i class="fas fa-calendar-check fa-3x" style={{ color: "#5E78FF" }}></i>
                    </div>
                    <div className="col-md-9 col-lg-9">
                      <label>
                        <strong>
                          Start Date
                        </strong>
                      </label>
                      <h4 >{moment(campaign.start_date).format("MMMM/DD/YY")}</h4>
                    </div>
                  </div>
                </div>
                <div className="col-2">
                  <div className="row">
                    <div className="col-md-3 col-lg-3 pt-1">
                      <i class="fas fa-calendar-times fa-3x" style={{ color: "#5E78FF" }}></i>
                    </div>
                    <div className="col-md-9 col-lg-9">
                      <label>
                        <strong>
                          End Date
                        </strong>
                      </label>
                      <h4 >{moment(campaign.end_date).format("MMMM/DD/YY")}</h4>
                    </div>
                  </div>

                </div>
                <div className="col-3">
                  <div className="row">
                    <div className="col-md-3 col-lg-3 pt-1">
                      {state === "On Going" ? <i class="fas fa-unlock-alt fa-3x" style={{ color: "#5E78FF" }}></i> : <i class="fas fa-lock fa-3x" style={{ color: "#5E78FF" }}></i>}
                    </div>
                    <div className="col-md-9 col-lg-9">
                      <label>
                        <strong>
                          Campaign Status
                        </strong>
                      </label>
                      <h4> <Badge variant={variants[state]}>{state}</Badge></h4>
                    </div>
                  </div>


                </div>
              </div>
              <div className="row p-10 pl-1">
                <div className="col-3">
                  <div className="row">
                    <div className="col-md-3 col-lg-3 pt-1">
                      <i class="fas fa-info-circle fa-3x" style={{ color: "#5E78FF" }}></i>
                    </div>
                    <div className="col-md-9 col-lg-9">
                      <label>
                        <strong>
                          Description
                        </strong>
                      </label>
                      <h4 >{campaign.description}</h4>
                    </div>
                  </div>


                </div>
                <div className="col-2">
                  <div className="row">
                    <div className="col-md-3 col-lg-3 pt-1">
                      <i class="fas fa-map-marked-alt fa-3x" style={{ color: "#5E78FF" }}></i>
                    </div>
                    <div className="col-md-9 col-lg-9">

                      <label>
                        <strong>
                          Locations
                        </strong>
                      </label>
                      <h4 >{campaign.pos?.length}</h4>
                    </div>
                  </div>

                </div>
                <div className="col-2">
                  <div className="row">
                    <div className="col-md-3 col-lg-3 pt-1">
                      <i class="fas fa-flag-checkered fa-3x" style={{ color: "#5E78FF" }}></i>
                    </div>
                    <div className="col-md-9 col-lg-9">

                      <label>
                        <strong>
                          Locations Visited
                        </strong>
                      </label>
                      <h4 >{posv}</h4>
                    </div>
                  </div>
                </div>
                <div className="col-2">
                  <div className="row">
                    <div className="col-md-3 col-lg-3 pt-1">
                      <i class="fas fa-redo-alt fa-3x" style={{ color: "#5E78FF" }}></i>
                    </div>
                    <div className="col-md-9 col-lg-9">
                      <label>
                        <strong>
                          Rounds
                        </strong>
                      </label>
                      <h4 >{round}</h4>
                    </div>
                  </div>
                </div>
                <div className="col-2">
                  <div className="row">
                    <div className="col-md-3 col-lg-3 pt-1">
                      <i class="fas fa-briefcase fa-3x" style={{ color: "#5E78FF" }}></i>
                    </div>
                    <div className="col-md-9 col-lg-9">
                      <label>
                        <strong>
                          Campaign type
                        </strong>
                      </label>
                      <h3> {(campaign.type ?? "").toUpperCase()}</h3>
                    </div>
                  </div>


                </div>
                {/* <div className="col-3">
                  <div className="row">
                    <div className="col-md-3 col-lg-3 pt-1">
                      <i class="fas fa-user-tie fa-3x" style={{ color: "#5E78FF" }}></i>
                    </div>
                    <div className="col-md-9 col-lg-9">
                      <label>
                        <strong>
                          Customer
                        </strong>
                      </label>
                      <h3>{client.name}</h3>
                    </div>
                  </div>
                </div> */}

              </div>

            </div>

         

          </div>

        </div>


      </>
    );
  }

  const [wave, setWave] = useState(null);
  useEffect(() => {
    if (campaign?.childs?.length && !wave) {
      const _wave = campaign?.childs.filter((c) => c.uid === campaign.uid)[0]
        ?.wave;
      setWave(_wave);
    }
  }, [campaign.childs, wave, campaign.uid]);

  useEffect(() => {
    async function fetchData() {
      setQueryRows(true)
      if (campaign.uid) {
        const __rows = await GenerateReport(campaign)
        const report = __rows.docs

        const pos = [...new Set(report.map(row => row.pos))]
        const pos_visited = pos.length
        console.log({ compe: __rows.competition })
        serCompetition(__rows.competition)
        setPosV(pos_visited)
        setRows(__rows.docs)
      }
      setQueryRows(false)

    }
    fetchData()
  }, [campaign])

  console.log([_rows, _competition])
  return (
    <>
      <RepeatCampaign show={repeat} onHide={() => setRepeat(!repeat)} campaing={campaign} />
      <PaymentWrapper {...controllers} campaing={campaign} />
      <div
        className="d-flex flex-column flex-column-fluid"
        id="kt_content"
      >
        <div className="">
          <div className=" ">
            <div className="d-flex justify-content-between pr-3">
              <Button variant="secondary" className="ml-2" onClick={() => history.goBack()}>
                <span className="svg-icon menu-icon">
                  <SVG src={toAbsoluteUrl("/media/svg/icons/Navigation/Arrow-from-right.svg")} />
                </span>
                <span>Back</span>
              </Button>
              <div className="row">

                <ExportReport uid={campaing_uid} rows={_rows} quering_results={quering_results}>
                </ExportReport>

              

              </div>
            </div>
            <br />

            <General />
            <br />

            <Tab.Container fluid activeKey={activaTab}>
              <Row>
                <Col lg={1} md={3} style={{ padding: "0" }} className="d-flex w-100 justify-content-end">
                  <Nav variant="buttons" className="flex-column mt-4" onSelect={setActiveTab}>
                    {[
                      {
                        name: "products",
                        icon: "fas fa-box",
                      },
                      {
                        name: "tasks",
                        icon: "fas fa-tasks",
                      },
                      {
                        name: "pos",
                        icon: "fas fa-map-marked-alt",
                      },
                      {
                        name: "agents",
                        icon: "fas fa-users",
                      },
                      {
                        name: "results",
                        icon: "fas fa-mobile",
                      },
                      {
                        name: "album",
                        icon: "fas fa-photo-video",
                      },
                      {
                        name: "planogram",
                        icon: "fas fa-layer-group",
                      },
                      {
                        name: "report",
                        icon: "fas fa-chart-bar",
                      }

                    ].map((nav) => (
                      <button
                        key={nav.name}
                        style={{ maxWidth: "100px" }}
                        className={`ml-5 mt-1 btn ${activaTab === nav.name
                          ? "btn-primary-custom"
                          : "btn-secondary"
                          }`}
                        onClick={() => setActiveTab(nav.name)}
                      >
                        <i
                          className={nav.icon}
                          style={{
                            fontSize: "25px", color: activaTab === nav.name
                              ? "white"
                              : "#5E78FF"
                          }}
                        ></i>
                        <br />
                        {nav.name.toUpperCase()}
                      </button>
                    ))}

                  </Nav>
                </Col>

                <Col lg={11} md={9} style={{ padding: "0", paddingRight: "12px" }}>
                  <Tab.Content unmountonexit="false" >
                    <Tab.Pane eventKey="agents">

                      <Agents
                        users={_users}
                        queryng={queryng_agents}
                        controllers={controllers}
                        // location={location}
                        campaign={campaign}
                      />

                    </Tab.Pane>
                    <Tab.Pane eventKey="pos">
                      <POSCard
                        rows={_rows}
                        pos={pos}
                        queryng={queryng_products}
                        campaign={campaign}
                      />
                    </Tab.Pane>
                    <Tab.Pane eventKey="tasks">

                      <Tasks
                        tasks={_tasks}
                        queryng={queryng_tasks}
                        campaign={campaign}
                      />
                    </Tab.Pane>
                    <Tab.Pane eventKey="products">
                      <Products
                        products={_products}
                        queryng={queryng_products}
                        campaign={campaign}
                      />
                    </Tab.Pane>
                    <Tab.Pane eventKey="results">
                      <Results
                        rows={[..._rows, ..._competition]}
                        tasks={_tasks}
                        queryng={quering_results}
                        campaign={campaign}
                      />
                    </Tab.Pane>
                    <Tab.Pane eventKey="album">
                      <Catalog
                        rows={_rows}
                        queryng={quering_results}
                        campaign={campaign}
                      />
                    </Tab.Pane>
                    <Tab.Pane eventKey="charts">
                      <Charts
                        rows={_rows}
                        tasks={_tasks}
                        products={_products}
                        childs={campaign.childs}
                      />
                    </Tab.Pane>
                    <Tab.Pane eventKey="report">
                      <Report
                        rows={_rows}
                        competition={_competition}
                        tasks={_tasks}
                        queryng={quering_results}
                        campaign={campaign}
                      />
                    </Tab.Pane>
                    <Tab.Pane eventKey="planogram">
                      <PlanoGram
                        rows={_rows}
                        campaign={campaign}
                        queryng={quering_results}
                        files={campaign.planograms}
                      />
                    </Tab.Pane>
                  
                  </Tab.Content>
                </Col>

              </Row>

            </Tab.Container>
          </div>
        </div>
      </div>
    </>
  );
}

export default injectIntl(connect(null, auth.actions)(CampaingsPreview));